// Models
import Model from './Model'

class SavingsAccount extends Model {
  get isNew () {
    return this.status === SAVINGS_ACCOUNT_STATUSES.NEW
  }

  get isOpened () {
    return this.status === SAVINGS_ACCOUNT_STATUSES.OPENED
  }

  static get statusOptions () {
    return [
      { name: 'New', value: SAVINGS_ACCOUNT_STATUSES.NEW },
      { name: 'Opened', value: SAVINGS_ACCOUNT_STATUSES.OPENED },
      { name: 'Closed', value: SAVINGS_ACCOUNT_STATUSES.CLOSED }
    ]
  }

  get schema () {
    return [
      'accountId',
      'amount',
      'clientRequestId',
      'createdAt',
      'currency',
      'id',
      'interestRate',
      'maturity',
      'profileId',
      'status'
    ]
  }
}

export const SAVINGS_ACCOUNT_STATUSES = {
  DRAFT: 'DRAFT',
  NEW: 'NEW',
  OPENED: 'OPENED',
  CLOSED: 'CLOSED',
  DECLINED: 'DECLINED'
}

export default SavingsAccount
